<h-icon-button
    [isKeyboardNavigationActive]="true"
    [appearance]="'SVG_WITH_TEXT_LEFT'"
    [textBoldUppercase]="true"
    [hasTransition]="hasTransition"
    [changeOpacityOnHover]="!productPageFacade.isProductPageRevampEnabled"
    [border]="false"
    [iconSize]="'14px'"
    [lineHeight]="'normal'"
    [style.display]="'flex'"
    (pressed)="openModal()">
    <h-svg-icon class="icon" [name]="'camera-flash'"></h-svg-icon>
    <span class="try-it-label label-small-bold-uppercase" i18n="@@hermes.product-page.vto-trybutton" text>
        Try On
    </span>
</h-icon-button>
